import React from "react";

import { Product } from "../../../interfaces";
import ActiveIngredientTags from "./ActiveIngredientTags";
import InactiveIngredientTags from "./InactiveIngredientTags";
import FavoriteProduct from "./FavoriteProduct";

interface Props {
  product: Product;
}

const ProductListItemLinks: React.FC<Props> = ({
  product: { links, name },
}) => {
  if (links.length === 0) {
    return (
      <div className="container">
        {/*<a href={`https://www.amazon.com/s?k=${name}`} target="_blank" rel="noopener noreferrer nofollow">
          <i className="fas fa-search" />
        </a>*/}
      </div>
    );
  }

  return (
    <div className="container">
      {links.map(({ source, link }) => {
        if (source === "amazon") {
          return (
            <a href={link} target="_blank" rel="noopener noreferrer nofollow">
              <i className="fab fa-amazon" />
            </a>
          );
        }
      })}
    </div>
  );
};

export default function ProductListItem(props: Props) {
  const { product } = props;
  const { id, name, brand, otherIngredients } = product;

  return (
    <div className="box content">
      <div className="columns">
        <div className="column">
          <p className="title is-4">{name}</p>
          <p className="title is-6">{brand}</p>
          <FavoriteProduct id={id} />
        </div>
        <div className="column">
          <p className="title is-6">Active Ingredients</p>
          <ActiveIngredientTags product={product} />

          {otherIngredients && (
            <p className="title is-6">Inactive Ingredients</p>
          )}
          <InactiveIngredientTags product={product} />
        </div>
      </div>
      <ProductListItemLinks product={product} />
    </div>
  );
}
